import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import styles from 'assets/css/ProgressWheel.module.css';
import CardLink from 'Components/Card/CardLink';
import { IconAngleRight, IconTargetArrows } from '@ace/react-icons';
import { allActions } from '@ace/react-utilities';

const Canvas = ({draw, canvasProps, ...props}) => {
    const canvasRef = useRef(null);
    const [context, setContext] = useState(null);

    useEffect(() => {
        if (canvasRef.current) {
            const renderCtx = canvasRef.current.getContext('2d');

            if (renderCtx) {
                renderCtx.scale(3,3);
                setContext(renderCtx);
            }
        }
    }, []);

    useEffect(() => {
        if (context) {
            draw(context);
        }
    }, [draw, context]);

    return <canvas className={styles.canvasWheel} ref={canvasRef} {...canvasProps} {...props} />;
}

export default Canvas;
